import { Box, Link, Typography } from '@mui/material'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'

const Disclaimer: React.FC = () => {
  return (
    <Box display="flex" flexDirection="column" padding={1}>
      <Typography variant="h1">XYO World Rules</Typography>
      <Typography variant="body1">
        These rules are written to reflect the functionality of the XYO World Smart Contracts. Smart Contracts are immutable; once they are deployed,
        they cannot be changed. Our goal with this is that the XYO Geotoken (Erc721) and the minting contract for them are fully decentralized after
        publishing. XYO will continue to provide a web interface to allow users to more easily call the smart contract and view the data from it, not
        unlike Etherscan.
      </Typography>
      <Typography variant="body1">
        In the case that there are any problems with the Smart Contract, XY is not able to change that. In the case where there is a bug in the XYO
        World Portal that interacts with the Smart Contract, XY can not provide any guarantees and only the Smart Contract itself should be used as an
        authoratative source of truth. In writing these Smart Contracts, every effort was taken to make sure that the rules as listed on this page are
        implemented to behave as expected, but due to the nature of decentralized systems, that can not be guaranteed.
      </Typography>
      <Typography variant="body1">
        Please note, that there are no fees that flow to the developers or to XY. All fees are between XYO World Geotoken holders only.
      </Typography>
      <Typography variant="body1">
        It continues to be a pleasure for myself and the entire XYO team to shepherd XYO into the future with projects like XYO World.
      </Typography>
      <Typography variant="body1">- Arie Trouw</Typography>
      <Box marginY={1}>
        <Typography variant="body1">
          Further explanation of these rules, I created&nbsp;
          <Link href="https://medium.com/xyonetwork/xyo-world-lowdown-annotated-rules-of-primary-sale-89d6728caefa" target="_blank">
            this article
          </Link>
          . Also, be sure to keep up with the&nbsp;
          <Link href="https://medium.com/xyonetwork" target="_blank">
            XYO blog
          </Link>
          &nbsp;for major news and changes as XYO World continues to grow and develop!
        </Typography>
        <Typography variant="body1">- Maryann Cummings</Typography>
      </Box>
      <Box marginY={1}>
        <Typography variant="body1">
          Note: Please see the{' '}
          <Link component={RouterLink} to="/fork">
            XYO World 2.0 Fork
          </Link>{' '}
          for more information about the recent update.
        </Typography>
      </Box>
    </Box>
  )
}

export default Disclaimer
